import { Component, Input } from '@angular/core';

@Component({
    selector: 'canvas-timeline-item',
    templateUrl: './timeline-item.component.html',
    styleUrls: ['./timeline-item.component.scss'],
    standalone: false
})
export class TimelineItemComponent {
  @Input() Last = false;
  @Input() Title = '';
  @Input() DisplayOffset = 0;
  @Input() Subtitle = '';
}
